export default __webpack_public_path__ + "static/app-features-1-f0d1b36f1b088f407efb736b169c7b06.webp";